import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';
import { Helmet } from 'react-helmet';

import {
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav,
} from '@coreui/react';

import { connect } from 'react-redux';

// sidebar nav config
import navigation from '../../_nav';
// routes config
import routes from '../../routes';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import { Page404 } from '../../views/Pages';
import { meAction } from '../../store/user/action';
import { authCheckState } from '../../store/auth/action';

export class DefaultLayout extends Component {
  componentWillMount() {
    Promise.all([
      this.props.isSecure(),
      this.props.me()
    ])   
  }
  render() {
    if(!this.props.token) {
      return null;
    }
    
    return (
      <div className="app">
        <Helmet
            titleTemplate="%s - Xelacore PLM Backoffice"
          >
          <title>Dashboard</title>
            <meta name="description" content="Xelacore PLM Backoffice" />
          </Helmet>
        <AppHeader fixed>
          <DefaultHeader/>
        </AppHeader>
        <div className="app-body">
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            <AppSidebarNav navConfig={ navigation } { ...this.props } />
            <AppSidebarFooter />
            <AppSidebarMinimizer />
          </AppSidebar>
          <main className="main">
            <AppBreadcrumb appRoutes={routes}/>
            <Container fluid>
              <Switch>
                {routes.map((route, idx) => {
                    return route.component 
                    ? (<Route 
                        key={idx} 
                        path={route.path} 
                        exact={route.exact} 
                        name={route.name} 
                        render={props => (
                          <route.component {...props} />
                        )} />)
                    : (null);
                  },
                )}
                <Redirect from="/" to="/dashboard" />
                <Route component={Page404} />                
              </Switch>
            </Container>
          </main>
        </div>
        <AppFooter>
          <DefaultFooter />
        </AppFooter>
      </div>
    );
  }
}

const mapStateToProps = ({ user, auth }) => {
  return {
    me: user.me,
    token: auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    me: () => dispatch(meAction()),
    isSecure: () => dispatch(authCheckState())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js